/*
  Custom Doussoux — sliding hover highlight for the desktop menu
  (INICIO, RUEDAS, FUSSION...), like histrips: one rounded highlight that
  glides from item to item following the mouse, and fades out when the
  mouse leaves the menu. Styles: assets/dsx-header-width.css (.dsx-menu-hl).
*/
(function () {
  var MENU = '.header-section ul.menu';
  var ITEM = ':scope > .menu__item';

  function titleOf(item) {
    return item.querySelector(':scope > .menu__title, :scope > details > .menu__title, :scope > * > .menu__title');
  }

  function indicator(menu) {
    var hl = menu.querySelector(':scope > .dsx-menu-hl');
    if (!hl) {
      hl = document.createElement('span');
      hl.className = 'dsx-menu-hl';
      hl.setAttribute('aria-hidden', 'true');
      menu.appendChild(hl);
    }
    return hl;
  }

  function moveTo(menu, item) {
    var title = titleOf(item);
    if (!title) return;
    var hl = indicator(menu);
    var m = menu.getBoundingClientRect();
    var t = title.getBoundingClientRect();
    var visible = hl.classList.contains('is-visible');
    if (!visible) hl.classList.add('no-slide');
    hl.style.width = t.width + 'px';
    hl.style.height = t.height + 'px';
    hl.style.transform = 'translate(' + (t.left - m.left) + 'px,' + (t.top - m.top) + 'px)';
    if (!visible) {
      void hl.offsetWidth; // place it without sliding in from the last position
      hl.classList.remove('no-slide');
    }
    hl.classList.add('is-visible');
  }

  function hide(menu) {
    var hl = menu.querySelector(':scope > .dsx-menu-hl');
    if (!hl) return;
    // keep it on an open dropdown's title
    var open = menu.querySelector(':scope > .menu__item details[open], :scope > .dsx-mega.is-open');
    if (open) { moveTo(menu, open.closest('.menu__item')); return; }
    hl.classList.remove('is-visible');
  }

  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var item = e.target.closest && e.target.closest('.menu__item');
    if (!item) return;
    var menu = item.parentElement;
    if (!menu || !menu.matches(MENU)) return;
    moveTo(menu, item);
  });

  document.addEventListener('mouseout', function (e) {
    var menu = e.target.closest && e.target.closest(MENU);
    if (!menu) return;
    if (e.relatedTarget && menu.contains(e.relatedTarget)) return;
    hide(menu);
  });
})();

/*
  Custom Doussoux — language follows the country picked in the country selector
  (same mapping the old Impulse theme used):
    Spanish (dsxhockey.shop/)  : ES, CL, AR, EC, CO, MX, UY, PE, PY
    French  (/fr)              : FR, BE
    English (/en)              : every other country
  The Doussoux country selector posts Shopify's localization form; we add the matching
  language_code to that request, and Shopify sends the visitor to /, /fr or /en.
  If a market doesn't have that language, Shopify keeps the market's default.
*/
(function () {
  var SPANISH = ['ES', 'CL', 'AR', 'EC', 'CO', 'MX', 'UY', 'PE', 'PY'];
  var FRENCH = ['FR', 'BE'];

  function languageFor(country) {
    if (SPANISH.indexOf(country) !== -1) return 'es';
    if (FRENCH.indexOf(country) !== -1) return 'fr';
    return 'en';
  }

  document.addEventListener('formdata', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.localization-form--country')) return;
    var country = (e.formData.get('country_code') || '').toString().toUpperCase();
    if (!country) return;
    e.formData.set('language_code', languageFor(country));
  }, true);
})();

/*
  Custom Doussoux — RUEDAS wheel menu (snippets/dsx-wheels-menu.liquid).
  Desktop: the cards panel opens on hover (or on the arrow / first tap on touch screens) and
  hangs under the whole black header pill, like histrips. Mobile side menu: RUEDAS is open by
  default and the + / − toggles it. Styles: assets/dsx-extras.css (section 7).

  The theme re-loads the whole desktop menu list a moment after the page loads (to fetch
  mega-menu content), so nothing here is tied to one element: every listener is page-level
  and the panel is re-attached each time the menu is rebuilt.
*/
(function () {
  var CLOSE_DELAY = 260;
  var state = { open: false, suppressHover: false, timer: null };

  var canHover = function () { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; };
  var items = function () { return document.querySelectorAll('.header-section [data-dsx-mega]'); };
  var panels = function () { return document.querySelectorAll('.dsx-mega-host > .dsx-mega__panel'); };

  function isInside(node) {
    if (!node || !node.closest) return false;
    return !!(node.closest('[data-dsx-mega]') || node.closest('.dsx-mega-host > .dsx-mega__panel'));
  }

  // Lift the header above the page while the panel is open (on inner pages the header has no
  // z-index, so videos, maps, galleries… were painted over the panel).
  var liftTimer = null;
  function lift(on) {
    clearTimeout(liftTimer);
    var apply = function () {
      panels().forEach(function (panel) {
        var section = panel.closest('.shopify-section') || panel.closest('header');
        if (!section) return;
        if (on) {
          if (!section.__dsxLift) {
            section.__dsxLift = { z: section.style.zIndex, pos: section.style.position };
          }
          if (getComputedStyle(section).position === 'static') section.style.position = 'relative';
          section.style.zIndex = '60';
        } else if (section.__dsxLift) {
          section.style.zIndex = section.__dsxLift.z;
          section.style.position = section.__dsxLift.pos;
          section.__dsxLift = null;
        }
      });
    };
    // on close, wait for the fade-out before dropping the header back
    if (on) apply(); else liftTimer = setTimeout(function () { if (!state.open) apply(); }, 260);
  }

  function paint() {
    lift(state.open);
    items().forEach(function (item) {
      item.classList.toggle('is-open', state.open);
      var title = item.querySelector('[data-dsx-mega-title]');
      if (title) title.setAttribute('aria-expanded', state.open ? 'true' : 'false');
    });
    panels().forEach(function (panel) { panel.classList.toggle('is-open', state.open); });
    if (!state.open) {
      document.querySelectorAll('.header-section ul.menu > .dsx-menu-hl.is-visible').forEach(function (hl) {
        if (!hl.parentElement.matches(':hover')) hl.classList.remove('is-visible');
      });
    }
  }

  function open() {
    clearTimeout(state.timer);
    if (state.open) return;
    state.open = true;
    paint();
  }
  function close() {
    clearTimeout(state.timer);
    if (!state.open) return;
    state.open = false;
    paint();
  }
  function closeSoon() {
    clearTimeout(state.timer);
    state.timer = setTimeout(close, CLOSE_DELAY);
  }

  // Move each (new) panel out of the menu list and hang it under the header pill.
  function adopt() {
    items().forEach(function (item) {
      var panel = item.querySelector('[data-dsx-mega-panel]');
      if (!panel) return;
      var host = item.closest('.header__wrapper') || item.closest('header-component') || item.closest('.header__row');
      if (!host) return;
      host.querySelectorAll(':scope > .dsx-mega__panel').forEach(function (old) { old.remove(); });
      host.appendChild(panel);
      host.classList.add('dsx-mega-host');
    });
    paint();
  }

  // Hover: the state always follows the mouse (re-entering always reopens;
  // leaving RUEDAS + the panel always closes).
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (!canHover()) return;
    if (isInside(e.target)) {
      clearTimeout(state.timer);
      if (!state.suppressHover) open();
    } else {
      state.suppressHover = false;
      if (state.open) closeSoon();
    }
  });
  // mouse leaves the browser window
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && state.open) {
      state.suppressHover = false;
      closeSoon();
    }
  });
  window.addEventListener('blur', function () { state.suppressHover = false; close(); });

  // Arrow toggles; RUEDAS text is a link (on touch screens the first tap opens the panel).
  document.addEventListener('click', function (e) {
    var title = e.target.closest && e.target.closest('[data-dsx-mega-title]');
    if (title) {
      if (e.target.closest('.dsx-mega__chevron')) {
        e.preventDefault();
        if (state.open) { close(); state.suppressHover = true; } else { state.suppressHover = false; open(); }
      } else if (!canHover() && !state.open) {
        e.preventDefault();
        open();
      }
      return;
    }
    if (state.open && !isInside(e.target)) close();
  });

  // keyboard
  document.addEventListener('focusin', function (e) {
    var title = e.target.closest && e.target.closest('[data-dsx-mega-title]');
    if (title) {
      try { if (title.matches(':focus-visible')) open(); } catch (err) {}
    } else if (state.open && !isInside(e.target)) {
      closeSoon();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) { close(); state.suppressHover = true; }
  });

  // the header hides when scrolling down: close with it
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (state.open && y > lastY + 40) close();
    if (!state.open) lastY = y;
  }, { passive: true });

  // mobile side menu: + / − toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dsx-mm-toggle]');
    if (!btn) return;
    var item = btn.closest('[data-dsx-mm]');
    if (!item) return;
    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // (re)attach whenever the theme rebuilds the header menu
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      var needs = false;
      items().forEach(function (item) { if (item.querySelector('[data-dsx-mega-panel]')) needs = true; });
      if (needs) adopt();
    }, 0);
  });

  function init() {
    adopt();
    document.querySelectorAll('.header-section').forEach(function (section) {
      if (section.__dsxMegaWatched) return;
      section.__dsxMegaWatched = true;
      observer.observe(section, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
